import { motion } from "framer-motion";

/**
 * MissionStatement — a quiet, high-conviction band between ClientOps and the
 * trust strip. It states plainly who NZ Taxation is for and why: we serve
 * small businesses that are aiming higher than where they are today.
 */
export default function MissionStatement() {
  return (
    <section
      className="relative bg-white border-b border-slate-200 overflow-hidden"
      data-testid="mission-statement"
    >
      <div
        aria-hidden
        className="absolute -top-24 left-1/2 -translate-x-1/2 w-[42rem] h-[42rem] bg-[#C9A349]/8 blur-3xl pointer-events-none"
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 py-20 md:py-28 text-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] font-bold text-[#C9A349]"
        >
          <span className="w-6 h-px bg-[#C9A349]" />
          Who we&apos;re for
          <span className="w-6 h-px bg-[#C9A349]" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="mt-6 font-heading font-black text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.02] text-[#0A192F]"
        >
          For small businesses <br />
          <span className="text-[#C9A349]">that think big.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.12 }}
          className="mt-8 text-slate-600 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto italic"
        >
          Because your business today doesn&apos;t have to define your business tomorrow.
        </motion.p>
      </div>
    </section>
  );
}
